var render, staticRenderFns
import script from "./AuthGrant.vue?vue&type=script&lang=js&"
export * from "./AuthGrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a14ff40')) {
      api.createRecord('3a14ff40', component.options)
    } else {
      api.reload('3a14ff40', component.options)
    }
    
  }
}
component.options.__file = "src/pages/AuthGrant.vue"
export default component.exports